import { Route } from 'react-router';

const GuestRoute = ({ path, component: Component }) => <Route exact path={path} component={Component} />;

export default GuestRoute;
